import { Injectable } from '@angular/core';
import { Action, State } from '@ngxs/store';
import type { StateContext } from '@ngxs/store';
import { TaskQuestionGroupsState } from '../task-question-groups/task-question-groups.state';
import * as Act from './task.actions';
import { TaskStateModel, taskStateDefaults } from './task.state.model';

@State<TaskStateModel>({
  name: 'task',
  defaults: taskStateDefaults,
  children: [TaskQuestionGroupsState]
})
@Injectable()
export class TaskState {
  @Action(Act.SetTask)
  public setTask(
    ctx: StateContext<TaskStateModel>,
    { task }: Act.SetTask
  ): void {
    ctx.patchState({
      item: {
        ...ctx.getState().item,
        data: task,
        query: { state: 'success' }
      }
    });
  }

  @Action(Act.ResetTask)
  public resetTask(ctx: StateContext<TaskStateModel>): void {
    ctx.setState(taskStateDefaults);
  }
}
